'use client';

import { GetWrapupType, WrapupModulePlayedData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModulePlaysComponent from "./playscomponent";

export default class WrapupModulePlays implements IWrapupModule {
    constructor() { }

    get id(): string { return 'plays'; }
    get name(): string { return 'Game Plays'; }

    canRender(data: GetWrapupType): boolean {
        return (data?.data?.played as WrapupModulePlayedData)?.numPlayed >= 0;
    }

    getComponentClass() {
        return WrapupModulePlaysComponent;
    }
}
